import styled, { css } from 'styled-components';

import { ReactComponent as Arrow } from '../svgs/rightarrow2.svg';
import { color, font } from './constants';
import { isDesktop } from '../config';

const buttonStyles = css`
  font-weight: ${font.mediumWeight};
  appearance: none;
  box-shadow: none;
  outline: none;
  border: none;
  border-radius: 5px;
  background: transparent;
  cursor: pointer;
  font-size: ${isDesktop() ? font.size13 : '1rem'};
  color: ${color.pelorous};
`;

const Button = styled.button`
  ${buttonStyles};
`;

const ButtonContainer = styled.div`
  position: absolute;
  bottom: 1.765rem;
  padding: 0 1.765rem 0 0.882rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

const BackArrow = styled(Arrow)`
  fill: ${color.grey4}
  min-width: 1.353rem;
  width: 1.353rem;
  height: 1.353rem;
  cursor: pointer;
  position: absolute;
  top: 0.882rem;
  left: 0.882rem;
  stroke: none;
`;

export default buttonStyles;
export { Button, ButtonContainer, BackArrow };
